import { render, staticRenderFns } from "./EditDataCommonNames.vue?vue&type=template&id=5ea315cb&"
import script from "./EditDataCommonNames.vue?vue&type=script&lang=js&"
export * from "./EditDataCommonNames.vue?vue&type=script&lang=js&"
import style0 from "./EditDataCommonNames.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports